export default __webpack_public_path__ + "73db234c700fac6dbe40aa553bda3bef.svg";